import { Module } from '@nestjs/common';
import { EmploymentStatusController } from './employment-status.controller';
import { EmploymentStatusService } from './employment-status.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployStatAdapter } from './dto/employment-status.adapter';
import { EmploymentStatus } from './employment-status.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([EmploymentStatus]),
  ],
  controllers: [EmploymentStatusController],
  providers: [EmploymentStatusService, EmployStatAdapter, ApplicationExceptionHandler,LogsService],
  exports: [EmploymentStatusService]
})
export class EmploymentStatusModule {}
